var map = {
	"./cricket-argentina-joins-ludimos-family.vue": [
		"0a3d",
		"chunk-4d8fb8aa"
	],
	"./cricket-serbia-joins-ludimos-family.vue": [
		"73ab",
		"chunk-49d1d1ad"
	],
	"./ludimos-brings-in-german-cricket-academys-head-coach-as-its-advisor.vue": [
		"1bf8",
		"chunk-06c73767"
	],
	"./ludimos-goes-into-bat-with-northerns-on-cricket-development.vue": [
		"e3bb",
		"chunk-ffcab876"
	],
	"./ludimos-technology-featured-in-cgtn.vue": [
		"e43c",
		"chunk-4c05328a"
	],
	"./sports-fever-360.vue": [
		"9a20",
		"chunk-c7529a52"
	],
	"./the-royal-dutch-cricket-association-partners-with-ludimos.vue": [
		"c148",
		"chunk-b6552686"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "f67e";
module.exports = webpackAsyncContext;